import { LANGS } from "@/i18n/prod";
import { Languages } from "lucide-react";

export function LanguageSwitcher({ lang, setLang }) {
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full border border-[#EBE8E3] bg-white p-1" data-testid="prod-lang-switcher" dir="ltr">
      <Languages className="h-3.5 w-3.5 text-stone-400 ml-1.5" />
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          data-testid={`prod-lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`text-xs font-semibold px-2.5 py-1 rounded-full [transition-property:background-color,color] duration-150 ${lang === l.code ? "bg-[#A83232] text-white" : "text-stone-500 hover:text-stone-800"}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
